import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {ModalFooter} from "../Components/BookingModalShell.jsx";
import {PrebookCompareDetail} from "../Components/prebookCompare.jsx";
import {filterSelectedCarDetails} from "@/utils/filesConstants.js";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {MODAL_STEPS} from "@/constants/steps";
import {img} from "@/utils/pluginImg.js";
import {comparePrices} from "@/utils/pricing.js";

const shortLabel = (dest) => {
    if (!dest) return '';
    const code = dest.address?.match(/\(([A-Z]{3})\)/);
    if (code) return code[1];
    if (dest.city) return dest.city;
    return (dest.address || '').split(',')[0].trim();
};

// Mobile step for the "Prebook vs Ride-Sharing" nested popup (desktop renders it
// inline as an .upper-modal in selectedCarDetailsLatest). Reuses the same
// PrebookCompareDetail component and class names — only the shell differs.
export function PrebookCompare(props) {
    const carDetails = filterSelectedCarDetails() || {};
    // Same two figures as the desktop popup (pre-tax net_total, and that total
    // without the online/coupon discounts) — see utils/pricing.js.
    const {price, sharePrice} = comparePrices(carDetails);
    const destinations = storage.get(STORAGE_KEYS.DESTINATIONS, []);
    const pickupLabel = shortLabel(destinations[0]);
    const dropoffLabel = shortLabel(destinations[1]);

    return (
        <>
            <ModalHeader
                title=""
                extraClasses="less-space"
                totalSteps={0}
                cancelButton={false}
                backStep={MODAL_STEPS.SELECTED_CAR_DETAILS}
                showBackButton={true}
                setStep={props.setStep}
                closeModal={props.closeModal}
            />

            <div className="modalPages-spacing padding-bottom-30">
                <PrebookCompareDetail
                    pickup={pickupLabel}
                    dropoff={dropoffLabel}
                    price={price}
                    sharePrice={sharePrice}
                />
            </div>

            <ModalFooter className="prebook-compare">
                <button
                    type="button"
                    className="pc-more-bar"
                    onClick={() => props.setStep(MODAL_STEPS.WHY_CHOOSE_US)}
                >
                    <span className="pc-more-left">
                        <img src={img("logo-latest.svg")} alt="hopn"/>
                        Exclusive Airport Pickup Perks
                    </span>
                    <span className="pc-more-link">More <img src={img("arrow-right.svg")} alt=""/></span>
                </button>
            </ModalFooter>
        </>
    );
}

export default PrebookCompare;
